// extracted by mini-css-extract-plugin
export default {"container":"style_container__guO6T","titleSection":"style_titleSection__AaDck","barChange":"style_barChange__T+qqc","barChangeLine":"style_barChangeLine__v0q17"};